import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import shared from "../../shared.module.css";
import { sizeOf } from "../../utils/propTypes";
import css from "./Spinner.module.css";

const Spinner = React.forwardRef(
  ({ size = "md", label = "Loading\u2026", className, ...rest }, ref) => {
    const classes = clsx(css[size], className);

    return (
      <div ref={ref} role="status" className={classes} {...rest}>
        <span className={shared.visuallyHidden}>{label}</span>
      </div>
    );
  },
);

Spinner.displayName = "Spinner";

Spinner.propTypes = {
  size: sizeOf("sm", "md", "lg"),
  label: PropTypes.string,
  className: PropTypes.string,
};

export default Spinner;
